export const actionTypes = {
	SET_PAGE: "SET_PAGE",

	SET_EVENT_CODE: "SET_EVENT_CODE",
};

